/**
 * Laakkonen page users can ask offers from Laakkonen company by using this form.
 * Class hold a logic for validating form input, rendering the form and sending an email containing
 * all information to Laakkonen.
 */
class CarSellForm {

  /**
   * @private
   * @property {object} element instances logic is bind to this element
   */
  #element;

  /**
   * @private
   * @property {object} dom HTMLElements from dom
   */
  #dom = {}

  /**
   * @constructor
   * @param {HTMLElement} element HTMLElement object to bind functionality
   */
  constructor(element) {
    this.#element = element;
    this.#findElements();
    this.#bindEventListener();
  }

  /**
   * Find components that need special attencion to work as intended
   */
  #findElements() {
    this.#dom.damageHistory = this.#element.querySelector('input[name="damage_history"]');
    this.#dom.damageHistoryError = this.#element.querySelector('.damage_history_error_message');
    this.#dom.tradeCarExtraInfoContainer = this.#element.querySelector('#trade-car-extrainfo-container');
    this.#dom.tradeCarExtraInfoCheckbox = this.#element.querySelector('#trade_car_extrainfo');
  }

  /**
   * Overrite binding process due we are operating on Laakkonen side
   */
  #bindEventListener() {
    this.#dom.tradeCarExtraInfoCheckbox.addEventListener('click', () => {
      this.#dom.tradeCarExtraInfoContainer.classList.toggle('hidden');
    });
  }

  /**
   * Called in master.js to initialize the car-sell-form on the page.
   * @static
   */
  static init() {
    document.querySelectorAll('.car-sell-form').forEach(element => {
      new CarSellForm(element);
    });
  }

}

export default {
  CarSellForm
}

export {
  CarSellForm
}
